import { useParams } from 'react-router-dom';
import { PageLayout } from '@/components/feature/PageLayout';
import { getCommuneBySlug } from '@/data/communes';
import { HeroCommune } from '@/pages/reparation-volet-commune/components/HeroCommune';
import { ContentCommune } from '@/pages/reparation-volet-commune/components/ContentCommune';
import { TrustCommune } from '@/pages/reparation-volet-commune/components/TrustCommune';
import { FAQCommune } from '@/pages/reparation-volet-commune/components/FAQCommune';
import { JsonLDCommune } from '@/pages/reparation-volet-commune/components/JsonLDCommune';
import NotFound from '@/pages/NotFound';

export default function CommunePage({ slug: slugProp }: { slug?: string } = {}) {
  const params = useParams<{ commune: string }>();
  const slug = slugProp || params.commune || '';
  const commune = getCommuneBySlug(slug);

  if (!commune) {
    return <NotFound />;
  }

  const { nom, codePostal, urlPath } = commune;
  const cpLabel = codePostal ? ` (${codePostal})` : '';

  const seo = {
    title: `Réparation de volets roulants à ${nom}${cpLabel} | Devis gratuit`,
    description: `Artisan spécialiste en réparation et dépannage de volets roulants à ${nom}${cpLabel} et dans le Hainaut. Volet bloqué, moteur HS, motorisation. Intervention rapide 7j/7, devis gratuit, garantie 10 ans. Appelez le 0800 20 410.`,
    keywords: `réparation volet roulant ${nom}, dépannage volet ${nom}, motorisation volet ${nom}, volet roulant bloqué ${nom}, réparateur volet roulant ${nom}${codePostal ? `, volet roulant ${codePostal}` : ''}`,
    canonicalUrl: urlPath,
  };

  return (
    <PageLayout seo={seo} devisFormCommune={nom}>
      <JsonLDCommune commune={commune} />
      <HeroCommune commune={commune} />
      <ContentCommune commune={commune} />
      <TrustCommune commune={commune} />
      <FAQCommune commune={commune} />
    </PageLayout>
  );
}